/**
 * Created by mcochrane on 25/08/17.
 */

export class ComponentDefinition {
  /**
   * Creates a Component Definition which defines everything
   * necessary to create a component.
   * @param id            string Unique id for this component type
   * @param type          string The name/type of the component (not necessarily unique)
   * @param md            string The regex in the markdown that gets replaced with a component
   * @param css           string Custom css to add for the component
   * @param html          string html to replace the regex (md) with
   * @param javascript    string javascript for this component
   * @param scripts       array[{name: string, data: string, isurl: boolean}]
   *                      name    name of the script
   *                      data    if isurl is false, the contents of the script (javascript)
   *                              or if isurl is true, the url to fetch the script from
   *                      isurl   true/false
   *                      type    'js' or 'css'
   * @param rawCompDef    {*}     The base unprocessed array that describes the note
   */
  constructor (id, type, md, css, html, javascript, scripts, rawCompDef) {
    this._raw = rawCompDef
    this.id = id
    this.type = type
    this.md = md
    this.css = css
    this.html = html
    this.js = javascript
    this.scriptDefs = (scripts || []).splice(0)
    this._jsScript = null
    this._cssScript = null
    this.addCssToScriptDefs()
    this.addJsToScriptDefs()
  }

  getJsScriptName () {
    return '__' + this.id + '_js__'
  }

  getCssScriptName () {
    return '__' + this.id + '_css__'
  }

  static SubmindVueComponentFunc = `let SubmindVueComponent = function (props) {
  props.errorCaptured = function (err, vm, info) { window.$ch.log(err.stack); return false; };
  if (!props.el) props.el = $tc.vueRootElSelector(); 
  return new Vue(props); 
}; `.replace('\n', '').replace('\r', '');

  /**
   * Instead of adding the full js code to the DOM for each instance, we add one copy of it as a script.
   */
  addJsToScriptDefs () {
    if (typeof this.js === 'string') {
      if (this.js.trim() !== '') {
        let scriptContents = 'window.' + this.getJsScriptName() + ' = function ($tc) {' + ComponentDefinition.SubmindVueComponentFunc + this.js + '\n}'
        this._jsScript = { name: this.getJsScriptName(), data: scriptContents, is_url: false, type: 'js' }
        this.scriptDefs.push(this._jsScript)
      }
    }
  }

  /**
   * Instead of adding the full css code to the DOM for each instance, we add one copy of it as a script.
   */
  addCssToScriptDefs () {
    if (typeof this.css === 'string') {
      if (this.css.trim() !== '') {
        this._cssScript = { name: this.getCssScriptName(), data: '\n' + this.css + '\n', is_url: false, type: 'css' }
        this.scriptDefs.push(this._cssScript)
      }
    }
  }

  deleteScripts () {

  }
}
